export type AggregationLevel = 'day' | 'week' | 'month' | 'year';

/**
 * Determine chart aggregation level from a date range (YYYY-MM-DD strings).
 * - <= 21 days: daily
 * - <= 60 days: weekly
 * - <= 36 months (~3 years): monthly
 * - > 36 months: yearly
 */
export function getAggregationLevel(
  startDate: string,
  endDate: string,
): AggregationLevel {
  const start = parseDateOnly(startDate);
  const end = parseDateOnly(endDate);
  const days = Math.ceil((end.getTime() - start.getTime()) / 86_400_000);

  if (days <= 21) return 'day';
  if (days <= 60) return 'week';
  if (days <= 36 * 30) return 'month';
  return 'year';
}

/**
 * Map aggregation level to a Highcharts xAxis label format string.
 * - day/week: 'Apr 5'  (specific date is meaningful)
 * - month:    'Apr 2026'
 * - year:     '2026'
 */
export function getChartDateFormat(level: AggregationLevel): string {
  if (level === 'day' || level === 'week') return '{value:%b %e}';
  if (level === 'month') return '{value:%b %Y}';
  return '{value:%Y}';
}

function parseDateOnly(dateString: string): Date {
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(Date.UTC(year, month - 1, day));
}
